import Link from "next/link";
import Image from "next/image";
import { getProductLink } from "@/lib/utils.js";
import DownloadLink from "@/components/download_link.js";
import ShareSvg from "@/components/svgs/share_svg.js";
import DownloadSvg from "@/components/svgs/download_svg.js";
import ResourceList from "@/components/resource_list";
import BulkAssetLinks from '@/components/bulk_asset_links'; 
import { useState } from "react";

export default function DownloadRow({
  download,
  resource_display,
  sharedAssetsEnabled,
  config
}) {
  const productLink = getProductLink(download);
  const downloads = download.downloads || {};
  const [showDownload, setShowDownload] = useState(false);
  const [showShare, setShowShare] = useState(false);

  return (
    <div className="lexcms-downloads-table-row-container">
      <div className="lexcms-downloads-table-row">
        <div
          className={
            "lexcms-downloads-table-value-box" +
            (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
          }
        >
          <div className="lexcms-downloads-table-product-image-container">
            <Link href={productLink}>
              <a>
                <Image
                  priority
                  src={download.image}
                  width={"65px"}
                  height={"65px"}
                  alt={""}
                  className="lexcms-product-downloads-image"
                />
              </a>
            </Link>
          </div>
        </div>
        <div
          className={
            "lexcms-downloads-table-value-box" +
            (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
          }
        >
          <p className="lexcms-downloads-table-values">
            <Link href={productLink}>{download.name}</Link>
          </p>
        </div>
        <div
          className={
            "lexcms-downloads-table-value-box" +
            (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
          }
        >
          <DownloadLink
            type={"Specsheets"}
            downloads={downloads}
            productLink={productLink}
            download={download}
            resource_display={resource_display}
          />
        </div>
        <div
          className={
            "lexcms-downloads-table-value-box" +
            (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
          }
        >
          <DownloadLink
            type={"Photometry"}
            downloads={downloads}
            productLink={productLink}
            download={download}
            resource_display={resource_display}
          />
        </div>
        <div
          className={
            "lexcms-downloads-table-value-box" +
            (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
          }
        >
          <DownloadLink
            type={"Brochures"}
            downloads={downloads}
            productLink={productLink}
            download={download}
            resource_display={resource_display}
          />
        </div>
        <div
          className={
            "lexcms-downloads-table-value-box" +
            (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
          }
        >
          <DownloadLink
            type={"Install Guides"}
            downloads={downloads}
            productLink={productLink}
            download={download}
            resource_display={resource_display}
          />
        </div>
        <div
          className={
            "lexcms-downloads-table-value-box" +
            (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
          }
        >
          <DownloadLink
            type={"BIM & CAD Files"}
            downloads={downloads}
            productLink={productLink}
            download={download}
            resource_display={resource_display}
          />
        </div>
        <div
          className={
            "lexcms-downloads-table-value-box" +
            (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
          }
        >
          <DownloadLink
            type={"Sell Sheets"}
            downloads={downloads}
            productLink={productLink}
            download={download}
            resource_display={resource_display}
          />
        </div>
        {sharedAssetsEnabled && (
          <div
            className={
              "lexcms-downloads-table-value-box" +
              (sharedAssetsEnabled ? " lexcms-share-assets-enabled" : "")
            }
          >
            <BulkAssetLinks product={download} config={config}/>
          </div>
        )}
        
      </div>
    </div>
  );
}
